const Platforms = {
  "label"   : "Platforms",
  "options" : [
    "PC",
    "Play Station",
    "XBOX",
    "VR"
  ]
}

export default Platforms